import { getToken } from "../utils/auth";
import { API_BASE_URL } from "./URL_Header";

const authHeaders = (json = true) => {
  const headers = { Authorization: `Bearer ${getToken()}` };
  if (json) headers["Content-Type"] = "application/json";
  return headers;
};

async function readError(response) {
  try {
    const data = await response.json();
    return data.message || data.title || `خطأ ${response.status}`;
  } catch {
    return `خطأ ${response.status}`;
  }
}

export const createReplacementOrder = async (payload) => {
  const response = await fetch(`${API_BASE_URL}/ReplacementOrder/Create`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify(payload),
  });
  if (!response.ok) throw new Error(await readError(response));
  return response.json();
};

export const fetchReplacementOrdersSummary = async () => {
  const response = await fetch(`${API_BASE_URL}/ReplacementOrder/Summary`, {
    headers: authHeaders(false),
  });
  if (!response.ok) throw new Error(await readError(response));
  return response.json();
};

export const fetchReplacementOrders = async ({ status = "All", page = 0, pageSize = 20 } = {}) => {
  const params = new URLSearchParams({
    page: String(page),
    pageSize: String(pageSize),
  });
  if (status) params.set("status", status);
  const response = await fetch(`${API_BASE_URL}/ReplacementOrder/List?${params}`, {
    headers: authHeaders(false),
  });
  if (!response.ok) throw new Error(await readError(response));
  return response.json();
};

export const fetchTicketAnalytics = async (params = {}) => {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") search.set(key, String(value));
  });
  const response = await fetch(`${API_BASE_URL}/Ticket/Analytics?${search}`, {
    headers: authHeaders(false),
  });
  if (!response.ok) throw new Error(await readError(response));
  return response.json();
};

export const retryReplacementWhatsApp = async (orderId) => {
  const response = await fetch(`${API_BASE_URL}/ReplacementOrder/${orderId}/RetryResolveWhatsApp`, {
    method: "POST",
    headers: authHeaders(false),
  });
  if (!response.ok) throw new Error(await readError(response));
  return response.json();
};
